import { checkValue, randmolyShuffledArray } from 'src/components/common/helper';
import { get } from 'lodash';

export const useCustomFilters = (data, loading, isRandom = 'False', method = '') => {
  let filterPropertySearchListings = [];
  let propertyStarRatings = [];
  let searchCriteria = undefined;

  if (!loading && checkValue(data) && checkValue(get(data, 'propertySearch.propertySearchListings', ''))) {
    if (method === 'CMS_LIST') {
      filterPropertySearchListings = data?.propertySearch?.propertySearchListings;
    } else {
      filterPropertySearchListings = data?.propertySearch?.propertySearchListings.filter((f) => {
        if (f.__typename === 'Property') {
          let priceValue =
            checkValue(f.price) && checkValue(f.price?.lead) && checkValue(f.price?.lead?.formatted)
              ? f.price?.lead?.formatted
              : undefined;
          // Check If return 0 price update to not visible
          if (checkValue(priceValue) && priceValue.indexOf('0') > -1) {
            const onlyPrice = priceValue.replace(/\D/g, '').trim();
            if (Number(onlyPrice) < 1) {
              priceValue = undefined;
            }
          }
          if (checkValue(priceValue)) {
            return f;
          }
        }
      });
    }

    // Random the property
    if (checkValue(filterPropertySearchListings, true)) {
      filterPropertySearchListings =
        isRandom === 'True' ? randmolyShuffledArray(filterPropertySearchListings) : filterPropertySearchListings;
    }

    if (method !== 'CMS_LIST') {
      // Get Star Rating It Is Coming Under Analytics
      propertyStarRatings = data?.extensions?.analytics?.[0]?.tealiumUtagData?.entity?.hotels?.results?.results;

      searchCriteria = data?.propertySearch?.searchCriteria?.dateRange;
    }
  }

  return { filterPropertySearchListings, propertyStarRatings, searchCriteria };
};
